module.exports = __webpack_public_path__ + "img/professioneel-logo-vr-games-at-home-nazareth-oculus-gaming-thuislevering-thumbnail.3d2a6dbf.png";